var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "btn btn-secondary btn-panel" },
    [
      _c("span", [_vm._v(_vm._s(_vm.name))]),
      _vm._v(" "),
      _c("el-popover", { attrs: { placement: "top", trigger: "hover" } }, [
        _c("div", [
          _c("div", [_vm._v("Size: " + _vm._s(_vm.size))]),
          _vm._v(" "),
          _c("div", [_vm._v("Type: " + _vm._s(_vm.type))]),
          _vm._v(" "),
          _c("div", [_vm._v("Duration: " + _vm._s(_vm.duration))]),
        ]),
        _vm._v(" "),
        _c("i", {
          staticClass: "fas fa-info-circle cursor-pointer ml-1",
          attrs: { slot: "reference" },
          slot: "reference",
        }),
      ]),
      _vm._v(" "),
      _vm.canPlay
        ? _c(
            "el-popover",
            {
              attrs: {
                content: "Play",
                trigger: "hover",
                placement: "top",
                "popper-class": "text-center",
              },
            },
            [
              _c("i", {
                staticClass: "fas fa-play cursor-pointer ml-1",
                attrs: { slot: "reference" },
                on: { click: _vm.play },
                slot: "reference",
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canStop
        ? _c(
            "el-popover",
            {
              attrs: {
                content: "Stop",
                trigger: "hover",
                placement: "top",
                "popper-class": "text-center",
              },
            },
            [
              _c("i", {
                staticClass: "fas fa-stop cursor-pointer ml-1",
                attrs: { slot: "reference" },
                on: { click: _vm.stop },
                slot: "reference",
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canRemove
        ? _c(
            "el-popover",
            {
              attrs: {
                content: "Remove",
                trigger: "hover",
                placement: "top",
                "popper-class": "text-center",
              },
            },
            [
              _c("i", {
                staticClass: "far fa-times-circle cursor-pointer ml-1",
                attrs: { slot: "reference" },
                on: { click: _vm.remove },
                slot: "reference",
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }